/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const CalendarPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The end date for the calendar
   */
  maxDate: PropTypes.instanceOf(Date),

  /**
   * The days from start date for the calendar
   */
  maxDaysFromMinDate: PropTypes.number,

  /**
   * The start date for the calendar
   */
  minDate: PropTypes.instanceOf(Date),

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default CalendarPropTypes;
